import { format } from "date-fns";
import React, { useState } from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import LoadingSpinner from "../../Components/spinner";
import { updateCommentStatus } from "../../services/axios/apiManager";
import { toast } from "sonner";

const BlogCommentDetails = ({
  showDetailsModal,
  selectedComment,
  closeDetails,
  fetchComments,
}) => {
  const [changing, setChanging] = useState(false);

  const handleUpdateStatus = async () => {
    setChanging(true);
    if (selectedComment?.id) {
      const response = await updateCommentStatus({
        id: selectedComment?.id,
        status: selectedComment?.status ? 0 : 1,
      });
      if (response?.data?.success) {
        toast.success(response.data.message);
        if (typeof fetchComments === 'function') fetchComments();
        if (typeof closeDetails === 'function') closeDetails();
      }
    }
    setChanging(false);
  };

  return (
    <Modal
      show={showDetailsModal}
      onHide={() => {
        closeDetails();
      }}
      centered
      backdrop="static"
      className="text-light"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title className="text-light">Blog Comment Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Row>
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div
              className="p-3 bg-secondary bg-opacity-10 rounded"
              style={{ overflow: "auto" }}
            >
              <span className="text-secondary fs-6 fw-semibold">Content</span>
              <span className={`d-block fs-5 fw-medium`}>
                {selectedComment?.content || "N/A"}
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          {Object.entries({
            "Posted By": `${selectedComment?.user?.first_name || ""} ${selectedComment?.user?.last_name || ""}`,
            Email: selectedComment?.user?.email || "",
            Status: selectedComment?.status ? "Approved" : "Pending",
            Date: selectedComment?.createdAt
              ? format(new Date(selectedComment?.createdAt), "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div
                className="p-3 bg-secondary bg-opacity-10 rounded"
                style={{ overflow: "auto" }}
              >
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
        <div className="container-fluid bg-dark my-2">
          <div className="d-flex justify-content-end align-items-center gap-2">
            {changing && <LoadingSpinner size={"md"} />}
            {!selectedComment?.status ? (
              <Button
                disabled={changing}
                variant="success"
                onClick={() => {
                  handleUpdateStatus();
                }}
              >
                Approve Comment
              </Button>
            ) : (
              <Button
                disabled={changing}
                variant="warning"
                onClick={() => {
                  handleUpdateStatus();
                }}
              >
                Set to Pending
              </Button>
            )}
            <Button variant="secondary" onClick={closeDetails} disabled={changing}>
              Close
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BlogCommentDetails;
